import axios from 'axios';
import { setAlert } from './alert';
import setAuthToken from '../utils/setAuthToken';

import {
    GET_REFERRAL_CONTENT,
    GET_ALL_REFERRAL_CONTENTS,
    GET_REFERRAL_CONTENT_REQUEST,
    CREATE_REFERRAL_CONTENT,
    UPDATE_REFERRAL_CONTENT,
    DELETE_REFERRAL_CONTENT,
    CLEAR_REFERRAL_CONTENT
} from './types';

const API_URL = process.env.REACT_APP_SERVER_API_URL;

// Get all Referral Contents
export const getReferralContents = () => async dispatch => {
    if (localStorage.token) {
        setAuthToken(localStorage.token);
    }
    dispatch({
        type: GET_REFERRAL_CONTENT_REQUEST,
        payload: true
    });

    try {
        const res = await axios.get(`${API_URL}/refer/content`);
        if (!res.data.error) {
            dispatch({
                type: GET_ALL_REFERRAL_CONTENTS,
                payload: res.data.data
            });
        } else {
            dispatch(setAlert(res.data.error, 'danger'));
        }
    } catch (err) {
        dispatch(setAlert('Failed to fetch Referral Contents', 'danger'));
    }
};

// Get a Referral Content
export const getReferralContent = id => async dispatch => {
    if (localStorage.token) {
        setAuthToken(localStorage.token);
    }
    dispatch({
        type: GET_REFERRAL_CONTENT_REQUEST,
        payload: true
    });
    try {
        const res = await axios.get(`${API_URL}/refer/content/${id}`);

        if (!res.data.error) {
            dispatch({
                type: GET_REFERRAL_CONTENT,
                payload: res.data.data
            });
            dispatch(setAlert('Successfully fetched Referral Content details', 'success'));
        } else {
            dispatch(setAlert(res.data.error, 'danger'));
        }
    } catch (err) {
        dispatch(setAlert('Error: Failed to get Referral Content details', 'danger'));
    }
};

// Add a Referral Content
export const addReferralContent = formData => async dispatch => {
    if (localStorage.token) {
        setAuthToken(localStorage.token);
    }
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    };

    try {
        const res = await axios.post(`${API_URL}/refer/content`, formData, config);
        if (!res.data.error) {
            dispatch({
                type: CREATE_REFERRAL_CONTENT,
                payload: res.data.content
            });
            dispatch(getReferralContents());
            dispatch(setAlert('Successfully created referral content', 'success'));
            return res.data.content; // Return the created content
        } else {
            dispatch(setAlert(res.data.error, 'danger'));
            return null;
        }
    } catch (err) {
        dispatch(setAlert('Error: Failed to create referral content', 'danger'));
        return null;
    }
};

// Update a Referral Content
export const updateReferralContent = (id, formData) => async dispatch => {
    if (localStorage.token) {
        setAuthToken(localStorage.token);
    }
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    };
    try {
        const res = await axios.put(`${API_URL}/refer/content/${id}`, formData, config);
        if (!res.data.error) {
            dispatch({
                type: UPDATE_REFERRAL_CONTENT,
                payload: res.data
            });
            dispatch(setAlert('Referral Content Updated', 'success'));
            dispatch(getReferralContents());
            dispatch(getReferralContent(id));
        } else {
            dispatch(setAlert(res.data.error, 'danger'));
        }
    } catch (err) {
        dispatch(setAlert('Error: Failed to update referral content', 'danger'));
    }
};

// Delete Referral Content
export const deleteReferralContent = (contentId) => async dispatch => {
    if (localStorage.token) {
        setAuthToken(localStorage.token);
    }
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    };
    try {
        const res = await axios.delete(`${API_URL}/refer/content/${contentId}`, config);

        if (!res.data.error) {
            dispatch({
                type: DELETE_REFERRAL_CONTENT,
                payload: contentId
            });
            dispatch(setAlert('Referral Content deleted successfully', 'success'));
            dispatch(getReferralContents());
        } else {
            dispatch(setAlert(res.data.error, 'danger'));
        }
    } catch (err) {
        dispatch(setAlert('Error: Failed to delete referral content', 'danger'));
    }
};

// Upload Referral Content Asset
export const uploadReferralContentAsset = (id, file) => async dispatch => {
    if (localStorage.token) {
        setAuthToken(localStorage.token);
    }
    
    const formData = new FormData();
    formData.append('file', file);
    
    try {
        const res = await axios.post(`${API_URL}/refer/asset/${id}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        
        if (!res.data.error) {
            dispatch(setAlert('Asset uploaded successfully', 'success'));
            // Refresh the referral content to get updated assets
            dispatch({
                type: UPDATE_REFERRAL_CONTENT,
                payload: res.data
            });
            dispatch(getReferralContent(id));
        } else {
            dispatch(setAlert(res.data.error, 'danger'));
            return null;
        }
    } catch (err) {
        dispatch(setAlert('Error: Failed to upload asset', 'danger'));
        return null;
    }
};

// Upload Benefit Icon
export const uploadBenefitIcon = (referralId, benefitId, file) => async dispatch => {
    if (localStorage.token) {
        setAuthToken(localStorage.token);
    }
    
    const formData = new FormData();
    formData.append('file', file);
    
    try {
        const res = await axios.post(`${API_URL}/refer/${referralId}/icon/${benefitId}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        
        if (!res.data.error) {
            dispatch(setAlert('Benefit icon uploaded successfully', 'success'));
            // Refresh the referral content to get updated data
            dispatch(getReferralContent(referralId));
            return res.data;
        } else {
            dispatch(setAlert(res.data.error, 'danger'));
            return null;
        }
    } catch (err) {
        dispatch(setAlert('Error: Failed to upload benefit icon', 'danger'));
        return null;
    }
};

// Clear Referral Content
export const clearReferralContent = () => dispatch => {
    dispatch({
        type: CLEAR_REFERRAL_CONTENT
    });
};